import { render, staticRenderFns } from "./DownloadAppModal.vue?vue&type=template&id=afa58b42&scoped=true"
import script from "./DownloadAppModal.vue?vue&type=script&lang=js"
export * from "./DownloadAppModal.vue?vue&type=script&lang=js"
import style0 from "./DownloadAppModal.vue?vue&type=style&index=0&id=afa58b42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa58b42",
  null
  
)

export default component.exports